export default function badgeName(badge) {
    const badgeMap = {
        'first': '#1',
        'team-member': 'Team',
        'looking-for-work': 'Looking for work',
    }

    return badgeMap[badge] || badge;
};
